<div class="flex flex-wrap">
  <div
    class="relative w-full xl:w-5/12 authBackground"
    [ngStyle]="{ 'background-image': 'url(' + backgroundImage + ')' }"
  ></div>

  <div class="relative w-full xl:w-7/12">
    <div class="login-card">
      <div>
        @if (loginType === 'pin') {
        <div class="login-main">
          <app-reset-password-pin-step (passwordSubmit)="onPasswordSubmit($event)"></app-reset-password-pin-step>
        </div>
        } @else {
        <div class="login-main">
          @if (!passwordRequested()) {
          <app-reset-password-form-step (passwordSubmit)="onPasswordSubmit($event)"></app-reset-password-form-step>
          } @if (passwordRequested()) {
          <form class="app-form">
            <h4>{{ 'MESSAGES.SUCCESS.SUCCESSFULLY_RESET_PASSWORD' | translate }}</h4>
            <p>{{ 'MESSAGES.SUGGESTIONS.PASSWORD_RESET_LOGIN_WITH_NEW_PASSWORD' | translate }}</p>
            <a [routerLink]="'/'" class="btn btn-gradient btn-block">{{ 'LABELS.SIGN_IN' | translate }}</a>
          </form>
          }
        </div>
        }
      </div>
    </div>
  </div>
</div>
